<template>
  <a :href="url" :target="target" class="owc-business-unit wb-card wb-card--mineshaft">
    <wb-card variant="dark-grey" class="owc-business-unit__card-inner">
      <wb-icon class="owc-business-unit__icon" :name="iconId" />
      <h4 class="wb-type-copy-secondary">{{ label }}</h4>
    </wb-card>
  </a>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { BusinessUnitComponent } from './BusinessUnitSwitch';
export default (ComponentInitializeDispatcher as BusinessUnitComponent).extend({
  name: 'owc-business-unit',
  props: {
    label: {
      type: String,
      required: true,
    },
    iconId: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    target: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss">
.owc-business-unit {
  position: relative;

  display: block;
  width: 100%;
  padding-top: 100%;

  white-space: normal;
  text-decoration: none;

  &__icon {
    width: 40px;
    height: 40px;

    opacity: 0.8;

    // Allow tracking to happen even if the user clicks on the BU icon
    pointer-events: none;

    @include breakpoint-from(mq3) {
      width: 56px;
      height: 56px;
    }
  }
  &__card-inner {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: var(--wb-spacing-xxs);

    text-align: center;

    opacity: 0.8;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
